import type { ThemeOptions } from '@mui/material/styles/createTheme'

import {
  breakpointsOptions,
  customCommonColors,
  customPalette,
  spacingConstants,
} from '../constants'

export const commonThemeOptions: ThemeOptions = {
  breakpoints: breakpointsOptions,

  typography: {
    fontFamily: 'Nunito, Figtree, sans-serif',
  },
  spacingConstants: {
    ...spacingConstants,
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
    MuiSkeleton: {
      defaultProps: {
        animation: 'wave',
      },
      styleOverrides: {
        rectangular: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        text: {
          fontFamily: ['Figtree', 'sans-serif'].join(','),
          fontSize: '16px',
          lineHeight: '24px',
          color: customCommonColors.blue15,
          borderRadius: '8px',

          '&:hover': {
            backgroundColor: customCommonColors.blue0,
          },
          '&:focus-visible': {
            outline: `solid 2px ${customCommonColors.black20}`,
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#FF6B6B',
          '&$error': {
            color: '#FF6B6B',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow:
            '0px 2px 4px rgba(19, 20, 21, 0.03), 0px 8px 8px rgba(19, 20, 21, 0.02);',
          borderRadius: '8px',
          boxSizing: 'border-box',
          border: `1px solid ${customCommonColors.grey0}`,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitTapHighlightColor: 'rgba(43, 207, 157, 0.3)',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 18,
          lineHeight: '28px',
          color: customPalette.tektiteBlack.main,
        },
        secondary: {
          fontSize: 14,
          lineHeight: '24px',
          color: customPalette.tektiteDark.main,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: customCommonColors.blue0,
          color: customCommonColors.blue15,
          fontWeight: 700,
        },
        deletable: {
          '&:focus': {
            backgroundColor: customCommonColors.blue5,
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: '#F5F8FF',
    },
    common: customCommonColors,
    primary: {
      main: customCommonColors.blue15,
      light: customCommonColors.blue10,
      dark: customCommonColors.blue20,
    },
    secondary: {
      main: '#36d1a2',
      contrastText: '#ffffff',
    },
    text: {
      primary: customCommonColors.black20,
      disabled: customCommonColors.grey5,
      secondary: customCommonColors.grey15,
    },
    error: {
      main: customCommonColors.red15,
      light: customCommonColors.red10,
      dark: customCommonColors.red20,
    },
    action: {
      disabled: customCommonColors.grey15,
    },
    ...customPalette,
  },
}
